export enum DiscontinuationRateMethodology {
  PROTOCOL_LEVEL = 'PROTOCOL_LEVEL',
  VISIT_LEVEL = 'VISIT_LEVEL',
}
